
const mappingImageComponents = {
  SECTION: {
    imageUrl: '[style].backgroundImageUrl',
    cropZoomPct: '[style].backgroundImageCropZoomPct',
    cropPosX: '[style].backgroundImageCropPosX',
    cropPosY: '[style].backgroundImageCropPosY',
    cropWidth: '[style].backgroundImageCropWidth',
    cropHeight: '[style].backgroundImageCropHeight',
    width: '[style].backgroundImageWidth',
    height: '[style].backgroundImageHeight',
  },
  SLIDE_PAGE: {
    imageId: '[style].backgroundImageID',
    imageType: '[style].backgroundImageType',
    imageUrl: '[style].backgroundImageUrl',
    imageName: '[style].backgroundImageName',
    imageTitle: '[style].backgroundImageTitle',
    imageWidth: '[style].backgroundImageWidth',
    imageHeight: '[style].backgroundImageHeight',
    imageAlt: '[style].backgroundImageAlt',
    cropZoomPct: '[style].backgroundImageCropZoomPct',
    cropPosX: '[style].backgroundImageCropPosX',
    cropPosY: '[style].backgroundImageCropPosY',
    cropWidth: '[style].backgroundImageCropWidth',
    cropHeight: '[style].backgroundImageCropHeight',
    width: '[style].backgroundImageWidth',
    height: '[style].backgroundImageHeight',
  },
  SLIDE_CONTAINER: {
    imageUrl: '[style].backgroundImageUrl',
    cropZoomPct: '[style].backgroundImageCropZoomPct',
    cropPosX: '[style].backgroundImageCropPosX',
    cropPosY: '[style].backgroundImageCropPosY',
    cropWidth: '[style].backgroundImageCropWidth',
    cropHeight: '[style].backgroundImageCropHeight',
    width: '[style].backgroundImageWidth',
    height: '[style].backgroundImageHeight',
  },
  SECTION_CELL: {
    imageUrl: '[style].backgroundImageUrl',
    cropZoomPct: '[style].backgroundImageCropZoomPct',
    cropPosX: '[style].backgroundImageCropPosX',
    cropPosY: '[style].backgroundImageCropPosY',
    cropWidth: '[style].backgroundImageCropWidth',
    cropHeight: '[style].backgroundImageCropHeight',
    width: '[style].backgroundImageWidth',
    height: '[style].backgroundImageHeight',
  },
  SECTION_WIDGET_IMAGE: {
    imageUrl: 'data.imageUrl',
    imageId: 'data.imageID',
    imageType: 'data.imageType',
    imageName: 'data.imageName',
    imageTitle: 'data.imageTitle',
    imageWidth: 'data.imageWidth',
    imageHeight: 'data.imageHeight',
    imageAlt: 'data.imageAlt',
    cropZoomPct: '[style].cropZoomPct',
    cropWidth: '[style].cropWidth',
    cropHeight: '[style].cropHeight',
    cropPosX: '[style].cropPosX',
    cropPosY: '[style].cropPosY',
    width: '[style].width',
    height: '[style].height',
  },
  SECTION_WIDGET_YOUTUBE: {
    imageUrl: 'data.coverImageUrl',
    imageId: 'data.coverImageId',
    cropZoomPct: '[style].coverImageCropZoomPct',
    cropWidth: '[style].coverImageCropWidth',
    cropHeight: '[style].coverImageCropHeight',
    cropPosX: '[style].coverImageCropPosX',
    cropPosY: '[style].coverImageCropPosY',
    width: '[style].width',
    height: '[style].height',
  },
  SECTION_WIDGET_INTERACTIVE: {
    imageId : '[style].backgroundImageID',
    imageType : '[style].backgroundImageType',
    imageUrl: '[style].backgroundImageUrl',
    imageAlt: '[style].backgroundImageAlt',
    imageTitle: '[style].backgroundImageTitle',
    imageName: '[style].backgroundImageName',
    cropZoomPct: '[style].backgroundImageCropZoomPercent',
    cropPosX: '[style].backgroundImageCropPosX',
    cropPosY: '[style].backgroundImageCropPosY',
    cropWidth: '[style].backgroundImageCropWidth',
    cropHeight: '[style].backgroundImageCropHeight',
    imageWidth: '[style].backgroundImageWidth',
    imageHeight: '[style].backgroundImageHeight',
  },
  SLIDE_ITEM: {
    imageUrl: '[style].backgroundImageUrl',
    cropZoomPct: '[style].backgroundImageCropZoomPct',
    cropPosX: '[style].backgroundImageCropPosX',
    cropPosY: '[style].backgroundImageCropPosY',
    cropWidth: '[style].backgroundImageCropWidth',
    cropHeight: '[style].backgroundImageCropHeight',
    width: '[style].backgroundImageWidth',
    height: '[style].backgroundImageHeight',
  },
  SLIDE_BLOCK: {
    imageUrl: '[style].backgroundImageUrl',
    cropZoomPct: '[style].backgroundImageCropZoomPct',
    cropPosX: '[style].backgroundImageCropPosX',
    cropPosY: '[style].backgroundImageCropPosY',
    cropWidth: '[style].backgroundImageCropWidth',
    cropHeight: '[style].backgroundImageCropHeight',
    width: '[style].backgroundImageWidth',
    height: '[style].backgroundImageHeight',
  },
  SYSTEM_WIDGET_IMAGE: {
    imageUrl: 'data.imageUrl',
    imageId: 'data.imageID',
    imageType: 'data.imageType',
    cropZoomPct: '[style].cropZoomPct',
    cropWidth: '[style].cropWidth',
    cropHeight: '[style].cropHeight',
    cropPosX: '[style].cropPosX',
    cropPosY: '[style].cropPosY',
    width: '[style].width',
    height: '[style].height',
  },
  HEADER_AREA: {
    imageUrl: '[style].backgroundImageUrl',
    cropZoomPct: '[style].backgroundImageCropZoomPct',
    cropPosX: '[style].backgroundImageCropPosX',
    cropPosY: '[style].backgroundImageCropPosY',
    cropWidth: '[style].backgroundImageCropWidth',
    cropHeight: '[style].backgroundImageCropHeight',
    width: '[style].backgroundImageWidth',
    height: '[style].backgroundImageHeight',
  },
  FOOTER_AREA: {
    imageUrl: '[style].backgroundImageUrl',
    cropZoomPct: '[style].backgroundImageCropZoomPct',
    cropPosX: '[style].backgroundImageCropPosX',
    cropPosY: '[style].backgroundImageCropPosY',
    cropWidth: '[style].backgroundImageCropWidth',
    cropHeight: '[style].backgroundImageCropHeight',
    width: '[style].backgroundImageWidth',
    height: '[style].backgroundImageHeight',
  },
}

const getStyleDevice = (detectDevice) => {
  switch (detectDevice) {
    case "mobile":
      return "styleMobile";
    case "tablet":
      return "styleTablet";
    default:
      return "style";
  }
}
const imageMapping = (type, device = 'desktop') => {
  const deviceStyle = getStyleDevice(device)
  return type ? JSON.parse(JSON.stringify(mappingImageComponents[type]).replaceAll('[style]', deviceStyle)) : {}
}
export {
  mappingImageComponents,
  imageMapping
}